import { Greyscale } from 'glints-aries';
import { Colors } from 'glints-aries/lib/@next';
import styled from 'styled-components';

import { GhostBtn } from '../../components/buttons';
import { device } from '../../components/screenSize';

export const Wrapper = styled.div`
  position: relative;
  background-color: ${Greyscale.white};
  margin: auto;
  margin-top: 10em;
  margin-bottom: 2em;
  z-index: 0;
  max-width: 360px;

  @media ${device.mobileL} {
    max-width: 420px;
  }
`;

export const Content = styled.div``;

export const UpperInnerContent = styled.div`
  padding: 2em 1.5em;
`;

export const LowerInnerContent = styled.div`
  padding: 1em 1.5em 2em;
`;

export const ButtonWrapper = styled.div`
  margin-bottom: 1em;
`;

export const ToCBox = styled.div`
  display: flex;
  padding: 1em;
  color: ${Greyscale.grey};
  background-color: ${Colors.Neutral.B99};
`;

export const SignUpSmallText = styled.div`
  padding: 0.5em 1em;
  margin-top: 0.5em;
  color: ${Greyscale.grey};
  display: flex;
  justify-content: space-between;
`;

export const Paragraph = styled.p`
  color: ${Greyscale.grey};
  margin: 0;
  align-self: center;
`;

export const ParagraphSignUpEmail = styled.p`
  font-size: 15px;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.6px;
`;

export const GhostBtnExt = styled(GhostBtn)`
  padding: 0.4em 0.6em;
  margin-left: 4em;
`;

export const IconSignUpEmail = styled.i`
  position: absolute;
  left: 0.5em;
  background-image: url('/images/onboarding/mail-icon.png');
  height: 20px;
  width: 20px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;

  @media ${device.mobileL} {
    left: 2em;
  }
`;
